var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { OWNER_SELECTED_BY_ID } from "./apps-nav-action";
import { USERDATA_RECEIVED } from "./userdata-action";

var initialState = {
    uniqueId: null,
    name: null,
    _owners: []
};

var ownerReducer = function ownerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case OWNER_SELECTED_BY_ID:
            if (state._owners.length) {
                return _extends({}, state, {
                    uniqueId: action.ownerId,
                    name: state._owners.find(function (owner) {
                        return parseInt(owner.uniqueId) === parseInt(action.ownerId);
                    }).title
                });
            } else {
                return _extends({}, state, {
                    uniqueId: action.ownerId
                });
            }
        case USERDATA_RECEIVED:
            if (state.uniqueId) {
                return _extends({}, state, {
                    _owners: action.museums,
                    name: action.museums.find(function (museum) {
                        return parseInt(museum.uniqueId) === parseInt(state.uniqueId);
                    }).title
                });
            } else {
                return _extends({}, state, {
                    _owners: action.museums
                });
            }
        default:
            return state;
    }
};

export default ownerReducer;